export enum LeaseTypeEnum {
  ASSIGNMENT = 'ASSIGNMENT',
  DIRECT = 'DIRECT',
  LICENSE = 'LICENSE',
  SUBLEASE = 'SUBLEASE',
  COWORKING = 'COWORKING',
  SHELL = 'SHELL',
  TURN_KEY = 'TURN_KEY',
}

export const LEASE_TYPE_ID_MAP: Record<LeaseTypeEnum, number> = {
  [LeaseTypeEnum.DIRECT]: 1,
  [LeaseTypeEnum.LICENSE]: 2,
  [LeaseTypeEnum.ASSIGNMENT]: 3,
  [LeaseTypeEnum.SUBLEASE]: 4,
  [LeaseTypeEnum.COWORKING]: 5,
  [LeaseTypeEnum.SHELL]: 6,
  [LeaseTypeEnum.TURN_KEY]: 7,
};

export enum LeaseBaseRentTime {
  Monthly = 'Monthly',
  Annual = 'Annual',
}

export enum EscalationType {
  Percentage = '%',
  Currency = 'currency',
  IndexLinked = 'index-linked',
  OpenMarketRent = 'open-market-rent',
}

export enum EscalationIncrement {
  FLAT = 'FLAT',
  ANNUAL = 'ANNUAL',
  MONTHLY = 'MONTHLY',
  EVERY2YRS = 'EVERY2YRS',
  EVERY3YRS = 'EVERY3YRS',
  EVERY4YRS = 'EVERY4YRS',
  EVERY5YRS = 'EVERY5YRS',
  EVERY6YRS = 'EVERY6YRS',
  EVERY7YRS = 'EVERY7YRS',
  EVERY8YRS = 'EVERY8YRS',
  EVERY9YRS = 'EVERY9YRS',
  EVERY10YRS = 'EVERY10YRS',
  STEPPED = 'STEPPED',
}

export enum EscalationIncrementIds {
  ANNUAL = 1,
  FLAT = 2,
  STEPPED = 3,
  EVERY2YRS = 4,
  EVERY3YRS = 5,
  EVERY4YRS = 6,
  EVERY5YRS = 7,
  EVERY6YRS = 8,
  EVERY7YRS = 9,
  EVERY8YRS = 10,
  EVERY9YRS = 11,
  EVERY10YRS = 12,
}

export enum LeaseRentType {
  FS = 'FS',
  IG = 'IG',
  NNN = 'NNN',
  NN = 'NN',
  N = 'N',
  MG = 'MG',
}

export enum LeaseRentPaymentDetails {
  FRI = 'FRI',
  IRI = 'IRI',
}

export const RentPaymentDetailsOptionsForUK = [
  {
    id: LeaseRentPaymentDetails.FRI,
    name: LeaseRentPaymentDetails.FRI,
  },
  {
    id: LeaseRentPaymentDetails.IRI,
    name: LeaseRentPaymentDetails.IRI,
  },
];

export enum LeaseTransactionType {
  NEW = 'New',
  EXPANSION = 'Expansion',
  RENEWAL = 'Renewal',
}

export enum LeaseRecordType {
  LEASE_COMPS = 'LEASE_COMPARABLES',
  LEASE_EXPIRATIONS = 'EXPIRATIONS',
  ALL_TENANTS = 'TENANT_LOCATION',
}

export enum LeaseFinancialStatusType {
  CONFIRMED = 'CONFIRMED',
  ESTIMATED = 'ESTIMATED',
}

export enum LeaseConfidentialType {
  yes = 'Yes',
  no = 'No',
}

export const LEASES_INITIAL_STATE = {
  data: null,
  isLoading: false,
  queryVariables: undefined,
};

export const LEASES_PAGE_SIZE = 50;

export enum LeasePeriodType {
  ANNUAL = 'ANNUAL',
  QUARTER = 'QUARTER',
}
